import { render, staticRenderFns } from "./VoiceCallModal.vue?vue&type=template&id=595b90f9&scoped=true"
import script from "./VoiceCallModal.vue?vue&type=script&lang=js"
export * from "./VoiceCallModal.vue?vue&type=script&lang=js"
import style0 from "./VoiceCallModal.vue?vue&type=style&index=0&id=595b90f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595b90f9",
  null
  
)

export default component.exports